import Vue from 'vue'
import VueI18n from 'vue-i18n'
import pl from 'vee-validate/dist/locale/pl.json'

Vue.use(VueI18n)

pl.messages.required = 'Pole jest wymagane'
pl.messages.email = 'Niepoprawny email'
pl.messages.regex = 'Format pola jest nieprawidłowy'
pl.messages.numeric = 'Pole może zawierać tylko cyfry'

const i18n = new VueI18n({
  locale: 'pl',

  messages: {
    pl: {
      fields: {
        location: 'Wybierz lokalizację',
        dateFrom: 'Data wyjazdu',
        dateTo: 'Data powrotu',
        clientName: 'Imię',
        clientSurname: 'Nazwisko',
        clientPesel: 'PESEL',
        clientDate: 'Data urodzenia',
        clientEmail: 'email',
        clientPhone: 'Nr telefonu'
      },
      validation: pl.messages
    }
  }
})

export { i18n }
